// extracted by mini-css-extract-plugin
export default {"heading":"GithubStats_heading__TkcSp","static":"GithubStats_static__YZfz8","float":"GithubStats_float__9QGd2","calen":"GithubStats_calen__OHFYn"};